import axiosInstance from '@/services/axiosInstance';
import type {
  ProcessBillingVendorConfirmResponse,
  ProcessBillingVendorGetResponse,
  ProcessBillingVendorPatchRequest,
  ProcessBillingVendorPostRequest,
  ProcessBillingVendorPostResponse,
} from '@/types/processBillingVendor.types';
import { type AxiosError } from 'axios';
import type { GenericErrorResponse } from '@brainvaulttech/dgr-react-sdk';

export async function getProcessBillingVendor(workOrderId: string): Promise<ProcessBillingVendorGetResponse> {
  const response = await axiosInstance.get<ProcessBillingVendorGetResponse>(
    `/work-orders/${workOrderId}/process-billing-vendor`
  );
  return response.data;
}

export async function postProcessBillingVendor(
  workOrderId: string,
  body: ProcessBillingVendorPostRequest
): Promise<ProcessBillingVendorPostResponse> {
  const response = await axiosInstance.post<ProcessBillingVendorPostResponse>(
    `/work-orders/${workOrderId}/process-billing-vendor`,
    body
  );
  return response.data;
}

export async function patchProcessBillingVendor(
  workOrderId: string,
  body: ProcessBillingVendorPatchRequest
): Promise<{ message: string }> {
  const response = await axiosInstance.patch<{ message: string }>(
    `/work-orders/${workOrderId}/process-billing-vendor`,
    body
  );
  return response.data;
}

export async function confirmProcessBillingVendor(workOrderId: string): Promise<ProcessBillingVendorConfirmResponse> {
  const response = await axiosInstance.post<ProcessBillingVendorConfirmResponse>(
    `/work-orders/${workOrderId}/process-billing-vendor/confirm`,
    {}
  );
  return response.data;
}

export interface SendVendorAffidavitRequest {
  documentIds: string[];
  mode: 'AFFIDAVIT' | 'AFFIDAVIT_WITH_INVOICE';
}

export interface SendVendorAffidavitResponse {
  sentTo: string[];
  cc: string[];
}

export async function sendProcessBillingVendorAffidavit(
  workOrderId: string,
  body: SendVendorAffidavitRequest
): Promise<SendVendorAffidavitResponse> {
  const response = await axiosInstance.post<SendVendorAffidavitResponse>(
    `/work-orders/${workOrderId}/process-billing-vendor/send-affidavit`,
    body
  );
  return response.data;
}

export function isProcessBillingVendorNotFoundError(err: unknown): boolean {
  const ax = err as AxiosError<GenericErrorResponse>;
  if (ax?.response?.status !== 404) return false;
  return true;
}
